import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useEffect } from 'react';

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

import mimixer from './img/digital/mimixer.png'
import miplanta from './img/digital/miplanta.png'
import miflota from './img/digital/miflota.png'
import miseguridad from './img/digital/miseguridad.png'
import miobra from './img/digital/miobra.png'
import sellodigital from './img/digital/sellodigital.jpg'
import infomix from './img/digital/infomix.jpg'
import alquimia from './img/digital/alquimia.png'
import conoenlinea from './img/digital/conoenlinea.png'
import optimix from './img/digital/optimix.png'

import Velocity from 'velocity-animate';

function App() {

  useEffect(() => {

    let blocks = document.querySelectorAll('.product-block');

    for (let i=0; i<blocks.length;i++) {
      Velocity.animate(blocks[i], { opacity: 1 }, { duration: 250, delay: i*100 });  
    }

  }, [])

  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={digital} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white t-54 pb-3">Apps</h3>    
                  </div>

                  <div className="col d-flex flex-row align-items-center">

                    <Link to="/digital/miobra" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={miobra} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">MiObra <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/mimixer" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={mimixer} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">MiMixer <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/miseguridad" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={miseguridad} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">MiSeguridad <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>                    

                    <Link to="/digital/miplanta" relative="path">
                      <div className="product-block d-flex flex-column">
                        <div className="product-block-upper flex-1">
                          <img src={miplanta} />
                        </div>
                        <div className="product-block-bottom">
                          <span className="product-block-bottom-text">MiPlanta <span className="chevron">></span></span>
                        </div>                    
                      </div>
                    </Link>

                    <Link to="/digital/miflota" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={miflota} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">MiFlota <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>





                    <Link to="/conoce" relative="path">
                      <div className="product-block d-flex flex-column">
                        <div className="product-block-upper flex-1">
                          <img src={miobra} style={{maxHeight: '100px'}} />
                          <p className="product-block-bottom-text text-center">Interactúa con MiObra <span className="chevron">></span></p>
                        </div>
                      </div>
                    </Link>
                    

                  </div>
                </div>
                
              </div>

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                  
                    <h3 className="text-white t-54 pb-3">Soluciones</h3>

                  </div>

                  <div className="col d-flex flex-row align-items-center">

                    <Link to="/digital/optimix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={optimix} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Optimix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/alquimia" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={alquimia} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Alquimia <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/sellodigital" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={sellodigital} style={{maxHeight: '220px'}} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">SelloDigital <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/conoenlinea" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={conoenlinea} style={{maxHeight: '220px'}} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Cono en Línea <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/infomix" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={infomix} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Infomix <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>

                    <Link to="/digital/accesoobra" relative="path">
                    <div className="product-block d-flex flex-column">
                      <div className="product-block-upper flex-1">
                        <img src={miobra} />
                      </div>
                      <div className="product-block-bottom">
                        <span className="product-block-bottom-text">Acceso a obra <span className="chevron">></span></span>
                      </div>                    
                    </div>
                    </Link>                    

                  </div>

                </div>





              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
